export default "__VITE_ASSET__6a8$DNwH__"